import React, { useEffect, useRef, useState } from "react";
import withdraw from "../../assets/Images/withdrawamount.svg";
import orange_icons from "../../assets/Images/orange coin flip.png";
import "../../styles/WithDrawAmount.css";
import {
  getUserDetailsByToken,
  GetWebAccessToken,
} from "../../components/ReusebleComponents/ResuseableApiCalls";
import axios from "axios";
import { FetchingWalletSchemaDetails } from "../../pages/WithDrawAmount/ServerFetchingCalls.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../assets/loader.json";
import payeebank from "../../assets/Images/payeebank.webp";
import Header from "../../components/Header/Header.js";
import Receipt from "../../components/NewReceipt/Receipt.js";
import { getPaymentStatus } from "../../Common/creditCardBinAPI/CommonFunctions.js";
import NtarLoader from "../../components/Loaders/NtarLoader.jsx";
import { data } from "../../Common/Text/NormalText.js";

const ProPartnerWithDrawAmount = () => {
  const [amountRelated, setAmountRelated] = useState({
    minAmountLimit: 0,
    maxAmountLimit: 0,
    availableBalance: 0,
    payoutFee: 0,
    payoutPercentage: 0,
    commissionFee: 0,
    commissionPercentage: 0,
  });
  const location = useLocation();

  const {
    availableWalletAmount = 0,
    withdrawAmount = 0,
    distributorsCount = 0,
  } = location.state || {};

  const [activepayOutGateWay, setActivePayOutGateWay] = useState("");
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [merchantDetails, setMerchantDetails] = useState("");
  const [errorMessages, setErrorMessages] = useState("");
  const [amount, setAmount] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [returnedResult, setReturnedResult] = useState("");
  const [receiptModal, setReceiptModal] = useState(false);
  const navigate = useNavigate();

  const isProcessingRef = useRef(false);

  const baseUrl = process.env.REACT_APP_BACKEND_URL;

  const generateTransactionId = () => {
    const now = new Date();
    const date = now.toISOString().slice(0, 10).replace(/-/g, "");
    const time = now.toISOString().slice(11, 19).replace(/:/g, "");
    const randomComponent = Math.random()
      .toString(36)
      .substr(2, 4)
      .toUpperCase();
    const transactionId = `BIZZ_${date}${time}${randomComponent}`;
    return transactionId;
  };

  const date = new Date();
  const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
  const optionsTime = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-GB", optionsDate);
  const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

  const handleAmountChange = (value) => {
    setErrorMessages("");
    const amounts = Number(value) || 0;
    setAmount(amounts);
  };

  useEffect(() => {
    if (bankList.length > 0) {
      const primaryBank = bankList.find(
        (bank) => bank.accountType?.toLowerCase() === "primary"
      );
      setSelectedBank(primaryBank || bankList[0]);
    }
  }, [bankList]);

  const handleFetchUserDetails = async () => {
    try {
      const fetchUserDetails = await getUserDetailsByToken();
      setMerchantDetails(fetchUserDetails);
      setBankList(fetchUserDetails?.bankDetails);
    } catch (error) {
      console.log("Error : while fetching merchant details", error);
    }
  };

  const handleFetchPayOutFee = async () => {
    setErrorMessages("");
    if (isProcessing) return;
    setIsProcessing(true);
    try {
      const maxMinAmountDataResp = await FetchingWalletSchemaDetails();
      if (maxMinAmountDataResp?.data?.message === "NoData") {
        setErrorMessages("Please Contact to help support");
        return;
      }
      if (maxMinAmountDataResp?.data?.length > 0) {
        setAmountRelated((prev) => ({
          ...prev,
          payoutFee: isNaN(parseFloat(maxMinAmountDataResp?.data[0]?.payOutFee))
            ? 0
            : parseFloat(maxMinAmountDataResp?.data[0]?.payOutFee),
          payoutPercentage: isNaN(
            parseFloat(maxMinAmountDataResp?.data[0]?.payOutPercentage)
          )
            ? 0
            : parseFloat(maxMinAmountDataResp?.data[0]?.payOutPercentage),
          commissionFee: isNaN(
            parseFloat(maxMinAmountDataResp?.data[0]?.commissionFee)
          )
            ? 0
            : parseFloat(maxMinAmountDataResp?.data[0]?.commissionFee),
          commissionPercentage: isNaN(
            parseFloat(maxMinAmountDataResp?.data[0]?.commissionPercentage)
          )
            ? 0
            : parseFloat(maxMinAmountDataResp?.data[0]?.commissionPercentage),
        }));
      } else {
        setAmountRelated((prev) => ({
          ...prev,
          payoutFee: 0,
          payoutPercentage: 0,
        }));
      }
    } catch (error) {
      console.log("Error while fetching payout charges", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleFetchAmountLimits = async () => {
    const token = await GetWebAccessToken();
    try {
      const response = await axios.get(
        `${baseUrl}/MinandMaxAmountLimit/get/all/service/amountLimits`,
        {
          headers: {
            "Content-Type": "Application/json",
            "Cache-Control": "no-cache",
    "Pragma": "no-cache",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let limitsData = response?.data?.data || [];
      const amountLimitDetails = limitsData?.filter(
        (items) =>
          items?.serviceName?.toString()?.toLowerCase() === "propartner"
      );
      if (amountLimitDetails?.length > 0) {
        setAmountRelated((prev) => ({
          ...prev,
          minAmountLimit: Number(amountLimitDetails[0]?.minAmount),
          maxAmountLimit: Number(amountLimitDetails[0]?.maxAmount),
        }));
      }
    } catch (error) {
      console.log("Error while fetching max min amount", error);
    }
  };

  const formatNumber = (num) => {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(2) + "k";
    }
    return num;
  };

  const handleFetchPermissiableTransaction = async (payOutDetails) => {
    try {
      const token = await GetWebAccessToken();
      const headers = {
        "Cache-Control": "no-cache",
    "Pragma": "no-cache",
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.post(
        baseUrl + "/transactions/getAccountNoAmountLimit",
        payOutDetails,
        { headers }
      );
      if (response?.status === 200 && response.data.proceed) {
        const respData = response?.data;
        return {
          dayAmount: respData?.remainingDayAmount,
          monthAmount: respData?.remainingMonthAmount,
          yearAmount: respData?.remainingYearAmount,
        };
      }
    } catch (error) {
      console.log("error===>====>", error.message);
    }
  };

  const fetchActivePaymentGateWay = async () => {
    const token = await GetWebAccessToken();
    const headers = {
      "Cache-Control": "no-cache",
    "Pragma": "no-cache",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axios.get(
        baseUrl + `/serviceTracking/get/serviceTracking`,
        { headers }
      );
      const serviceDetails = response?.data?.data?.filter(
        (items) =>
          items?.serviceName !== "PayOut_Settlements" &&
          items?.serviceFor === "PayOut_Settlements" &&
          items?.serviceStatus === "Active"
      );
      if (serviceDetails && serviceDetails.length > 0) {
        setActivePayOutGateWay(serviceDetails[0]?.serviceName);
      } else {
        setActivePayOutGateWay("");
      }
    } catch (error) {
      console.log("error while fetching active payment gatway===>", error);
      console.log(
        "error while fetching active payment gatway===>",
        error?.response?.data
      );
    }
  };

  const fetchData = async () => {
    try {
      await Promise.all([
        handleFetchUserDetails(),
        handleFetchPayOutFee(),
        handleFetchAmountLimits(),
        fetchActivePaymentGateWay(),
      ]);
    } catch (error) {
      console.error("Error occurred while calling APIs:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const addBeneficiaryRazorPay = async (payOutDetails) => {
    try {
      const token = await GetWebAccessToken();
      const headers = {
        "Cache-Control": "no-cache",
    "Pragma": "no-cache",
        Authorization: `Bearer ${token}`,
      };

      const detailsToSendBackEnd = {
        beneficiaryName: payOutDetails?.payOutName,
        beneficiaryIfscCode: payOutDetails?.payOutIFSCNumber,
        beneficiaryAccountNumber: payOutDetails?.payOutAccountNumber,
        createdDate: formattedDate,
        createdTime: formattedTime,
      };
      const response = await axios.post(
        baseUrl + "/createpayoutRazorPay/bendetails",
        detailsToSendBackEnd,
        { headers }
      );

      const contactId = response?.data?.contactId;
      const fundAccountId = response?.data?.fundAccountId;
      const numericAmount =
        typeof amount === "string"
          ? Number(amount.replace(/,/g, ""))
          : Number(amount);

      return {
        contactId,
        fundAccountId,
        finalPayableAmount: numericAmount,
        amount: numericAmount,
        actualAmount: numericAmount,
        serviceName: "ProPartner_Settlements",
        subService: "ProPartner_Settlements",
        beneficiaryName: payOutDetails?.payOutName,
        beneficiaryAccountNumber: payOutDetails?.payOutAccountNumber,
        ifscCode: payOutDetails?.payOutIFSCNumber,
      };
    } catch (error) {
      console.log("error while adding benefciary in razor pay===>", error);
    }
  };

  const calculatePayOutCharges = (numericAmount) => {
    let fee = 0;
    if (Number(amountRelated?.payoutFee) > 0) {
      fee = Number(amountRelated?.payoutFee);
    } else if (Number(amountRelated?.payoutPercentage) > 0) {
      fee = numericAmount * (Number(amountRelated?.payoutPercentage) / 100);
    }
    return fee;
  };

  const handleCreatePayOut = async () => {
    if (isProcessing || isProcessingRef.current) {
      console.log("Processing in progress,double click detected");
      return;
    }
    isProcessingRef.current = true;
    setIsProcessing(true);
    setErrorMessages("");
    const token = await GetWebAccessToken();
    const headers = {
      "Cache-Control": "no-cache",
    "Pragma": "no-cache",
      Authorization: `Bearer ${token}`,
    };
    const payOutDetails = {
      payOutName: selectedBank?.accountname,
      MerchantId: merchantDetails?.MerchantId,
      payOutMobileNumber: selectedBank?.vendorPhoneNumber,
      mobileNumber: selectedBank?.mobileNumber || merchantDetails?.mobileNumber,
      payOutPanName: selectedBank?.panName || merchantDetails?.panNumber,
      payOutPanNumber: selectedBank?.panNumber,
      payOutAccountNumber: selectedBank?.accountNo,
      payOutIFSCNumber: selectedBank?.accountIFSCCode,
      payOutFundAccountId: "",
      payOutContactId: "",
      payOutActiveStatus: "Active",
      payOutAccountHolderName: selectedBank?.accountname,
    };
    const ntarTransactionId = await generateTransactionId();
    const beneficiaryDetails = await addBeneficiaryRazorPay(payOutDetails);
    const permissibleLimits = await handleFetchPermissiableTransaction({
      ...payOutDetails,
      payOutFundAccountId: beneficiaryDetails?.fundAccountId,
      payOutContactId: beneficiaryDetails?.contactId,
    });

    try {
      const numericAmount =
        typeof amount === "string"
          ? Number(amount.replace(/,/g, ""))
          : Number(amount);

      if (
        !beneficiaryDetails?.contactId ||
        !beneficiaryDetails?.fundAccountId
      ) {
        console.log("contact id and fund Account id not found");
        setErrorMessages("Please Refresh And try again later");
        return;
      }

      if (
        Number(amountRelated?.payoutFee) <= 0 &&
        Number(amountRelated?.payoutPercentage) <= 0
      ) {
        console.log("payoutFee and payoutPercentage not found");
        setErrorMessages(
          "Payout Unavailable ,Charges not configured. Please try again later."
        );
        return;
      }

      if (!activepayOutGateWay || activepayOutGateWay.trim() === "") {
        console.log("activepayOutGateWay and activepayOutGateWay not found");
        setErrorMessages(
          "Payout Unavailable,No active payout gateway found. Please try again later."
        );
        return;
      }
      if (
        Number(amountRelated?.minAmountLimit) <= 0 &&
        Number(amountRelated?.maxAmountLimit) <= 0
      ) {
        console.log(
          "minAmountLimit and maxAmountLimit id not found",
          amountRelated?.minAmountLimit,
          amountRelated?.maxAmountLimit
        );
        setErrorMessages(
          "Payout Unavailable , Transaction limits are not set. Please try again later."
        );
        return;
      }

      if (
        !(Number(numericAmount) >= Number(amountRelated?.minAmountLimit)) ||
        !(Number(numericAmount) <= Number(amountRelated?.maxAmountLimit))
      ) {
        console.log(
          "Amount shoud be greater than",
          amountRelated?.minAmountLimit,
          "and less than",
          amountRelated?.maxAmountLimit
        );
        setErrorMessages(
          `Amount shoud be greater than ${amountRelated?.minAmountLimit} and and less than ${amountRelated?.maxAmountLimit}`
        );
        return;
      }
      if (
        !(
          numericAmount <= permissibleLimits?.dayAmount &&
          numericAmount <= permissibleLimits?.monthAmount &&
          numericAmount <= permissibleLimits?.yearAmount
        )
      ) {
        console.log(
          "dayAmount , monthAmount and yearAmount id not found",
          permissibleLimits?.dayAmount,
          permissibleLimits?.monthAmount,
          permissibleLimits?.yearAmount
        );
        setErrorMessages(
          `Invalid Amount Please verify remaining day limit - ${
            permissibleLimits?.dayAmount?.toFixed(2) || 0
          }, month limit ${
            permissibleLimits?.monthAmount?.toFixed(2) || 0
          }, and year limit ${permissibleLimits?.yearAmount?.toFixed(2) || 0}.`
        );
        return;
      }
      const payOutCharges = calculatePayOutCharges(numericAmount);
      const tdsCharges = numericAmount * 0.05;
      const totalAmount = numericAmount + payOutCharges;
      if (availableWalletAmount < totalAmount) {
        setErrorMessages(
          "Insufficient Balance , Oops! It looks like your wallet doesn't have enough funds to complete this payment. Please add funds or reduce the amount to proceed."
        );
        return;
      }

      const newDetails = {
        ...beneficiaryDetails,
        serviceName: "ProPartner_Settlements",
        subService: "ProPartner_Settlements",
        payInRequired: "NO",
        walletSettlementRequired: "YES",
        finalPayableAmount: 0,
        paymentMode: "ProPartner",
        MerchantId: merchantDetails?.MerchantId,
        userName: merchantDetails?.userName,
        mobileNumber: merchantDetails?.mobileNumber,
        walletAmount: totalAmount,
        payOutFee: amountRelated?.payoutFee,
        payOutPercentage: amountRelated?.payoutPercentage,
        paymentMethod: "ProPartner",
        ntarTransactionId,
        paymentGateWay: "",
        payOutGateWay: activepayOutGateWay,
        actualAmount: numericAmount,
        amount: totalAmount,
        chargedAmount: payOutCharges,
        payOutChargedAmount: payOutCharges,
        payOutAccountNumber: selectedBank?.accountNo,
        payOutIFSCNumber: selectedBank?.accountIFSCCode,
        beneficiaryName: selectedBank?.accountname,
        beneficiaryPan: merchantDetails?.accountname,
        tdsPercentage: 5,
        tdsCharges: tdsCharges,
      };
      if (!newDetails?.contactId || !newDetails?.fundAccountId) {
        setErrorMessages(
          "Internal Server Error",
          " Please refresh and try again."
        );
        return;
      }
      const response = await axios.post(
        baseUrl +
          "/SettlementTransactions/save/ProPartner_balanceWithdraw/transactions",
        newDetails,
        { headers }
      );
      if (response.status === 200 && response?.data) {
        setReturnedResult(response.data);
        setReceiptModal(true);
      }
    } catch (error) {
      console.log("Error While creating Payout===>", error);
      setErrorMessages(error?.response?.data?.message);
    } finally {
      setIsProcessing(false);
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Loader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (isProcessing) {
    return <NtarLoader />;
  }

  const handleCloseModal = () => {
    setReceiptModal(false);
    navigate("/Payouts", { replace: true });
  };

  const handleBank = (bank) => {
    if (amount && amount > 0) {
      setSelectedBank(bank);
    } else {
      setErrorMessages("Enter Amount");
    }
  };

  if (receiptModal) {
    return (
      <Receipt
        type={getPaymentStatus(returnedResult)}
        receiptData={returnedResult}
        handleClose={handleCloseModal}
        center={true}
      />
    );
  }

  return (
    <div>
      <Header title="Payout’s Dashboard" />

      <div className="qr-form-withdraw">
        <div className="stats-grid-withdraw">
          <div className="stat-card-1-withdraw">
            <div className="stat-header-withdraw">
              <img src={withdraw} />
              <h3>{data?.withdraw}</h3>
            </div>
            <hr className="gradient-line-withdraw" />
            <div className="values-full-div-withdraw">
              <div className="stat-value-withdraw">
                ₹ {formatNumber(availableWalletAmount)}
              </div>
              <div>
                <span className="trend positive-withdraw">
                  {data?.withdraw} : ₹ {formatNumber(withdrawAmount)}
                </span>
                <p className="stat-period-withdraw">
                  {data?.Referral} {formatNumber(distributorsCount)} {data?.nos}
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <hr className="gradient-line-withdraw" />
        <br />
        <div className="enter-amount-div-withdraw">
          <div className="amount-div-contact">
            <div className="w-30">
              {errorMessages && (
                <p style={{ color: "var(--red)" }}>{errorMessages}</p>
              )}
              <div style={{ textAlign: "center" }}>
                <div className="fs-4 fw-bold" style={{ marginBottom: "1rem" }}>
                  {data?.enterAmount}
                </div>
                <div className="Amount-rupee-div-contact-v">
                  <input
                    value={amount ? `₹ ${amount}` : ""}
                    placeholder="₹ 0"
                    type="text"
                    className="input_contact"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      handleAmountChange(value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="Linewith_coin-withdraw">
            <img src={orange_icons} alt="coin" width={15} className="coinImg" />
          </div>
          <br />
          <br />
          <div className="checkbox-ntar-coins">
            {merchantDetails &&
              typeof merchantDetails === "object" &&
              merchantDetails?.bankDetails &&
              Array.isArray(merchantDetails?.bankDetails) &&
              merchantDetails?.bankDetails.map((bankDetails, bankIndex) => {
                return (
                  <div
                    key={bankIndex}
                    onClick={() => handleBank(bankDetails)}
                    className={
                      Number(bankDetails?.accountNo) ==
                      Number(selectedBank?.accountNo)
                        ? "mrchntExist-banklDtls-card_change"
                        : "mrchntExist-banklDtls-card"
                    }
                  >
                    <div className="contact-account-withdraw">
                      <p className="contact-initial-withdraw">
                        {bankDetails?.accountname?.charAt(0)}
                      </p>
                    </div>
                    <div className="contact-info_s">
                      <p className="contact-name">{bankDetails?.accountname}</p>
                      <p className="contact-account-withdraw">
                        <img className="payeebank" src={payeebank} />
                         A/C:
                        {bankDetails?.accountNo} ({bankDetails?.accountIFSCCode}
                        )
                      </p>
                    </div>
                  </div>
                );
              })}
          </div>

          <br />
          <button
            className="continue-btn-withdraw"
            disabled={
              !(
                selectedBank !== "" &&
                parseFloat(amount) <= parseFloat(availableWalletAmount) &&
                parseFloat(amount) > 0
              ) || isProcessing
            }
            onClick={() => handleCreatePayOut()}
          >
            {data?.continue}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProPartnerWithDrawAmount;
